module.exports = __webpack_public_path__ + "static/media/Why Choose 5.c564eb3c.png";